import type { AxiosWrapperConfig } from '@mylight150/axios-wrapper';

const axiosWrapperConfig: AxiosWrapperConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  authRequired: import.meta.env.VITE_AUTH_REQUIRED === 'true',
  ocpSubscriptionKey: import.meta.env.VITE_OCP_SUBSCRIPTION_KEY,
  ocpSubscriptionKeyHeaderName: import.meta.env.VITE_OCP_SUBSCRIPTION_KEY_HEADER_NAME,
  getAccessToken: async () => {
    return null;
  },
  onError: () => {},
};

export default axiosWrapperConfig;
